import t from "react";
import { Tabs as _ } from "../../../Tabs/Tabs.js";
import { Tab as d } from "../../../Tabs/components/Tab/Tab.js";
import { TabContent as m } from "./TabContent.js";
import { ContentLinks as c } from "./ContentLinks.js";
import { sendClickEvent as b } from "../../utils/sendClickEvent.js";
import { StaticFooter as h } from "../Static/StaticFooter.js";
import { cls as k } from "../../../../helpers/cls.js";
const o = "footer",
  L = _ref => {
    let {
      firstGroupTabLinks: e,
      secondGroupTabLinks: i,
      thirdGroupTabLinks: r,
      fourthGroupTabLinks: a,
      newMaxWidth: V,
      className: E
    } = _ref;
    var u, p, f;
    const [l, n] = t.useState("ds-tab-primario"),
      v = (f = (p = (u = e == null ? void 0 : e.title) != null ? u : i == null ? void 0 : i.title) != null ? p : r == null ? void 0 : r.title) != null ? f : a == null ? void 0 : a.title,
      T = s => {
        s === "ds-tab-primario" && (b("first_tab", o), n("ds-tab-primario")), s === "ds-tab-secundario" && (b("second_tab", o), n("ds-tab-secundario")), s === "ds-tab-terciario" && (b("third_tab", o), n("ds-tab-terciario")), s === "ds-tab-quaternario" && (b("fourth_tab", o), n("ds-tab-quaternario"));
      };
    return t.createElement("footer", {
      className: k("olx-seo-footer", E),
      id: "footer",
      "data-ds-component": "DS-Footer"
    }, v && t.createElement(_, {
      isPersistent: !0,
      onChange: T
    }, (e == null ? void 0 : e.title) && t.createElement(d, {
      id: "ds-tab-primario",
      label: e.title
    }, t.createElement(m, {
      isVisible: l === "ds-tab-primario"
    }, t.createElement(c, null, e))), (i == null ? void 0 : i.title) && t.createElement(d, {
      id: "ds-tab-secundario",
      label: i.title
    }, t.createElement(m, {
      isVisible: l === "ds-tab-secundario"
    }, t.createElement(c, null, i))), (r == null ? void 0 : r.title) && t.createElement(d, {
      id: "ds-tab-terciario",
      label: r.title
    }, t.createElement(m, {
      isVisible: l === "ds-tab-terciario"
    }, t.createElement(c, null, r))), (a == null ? void 0 : a.title) && t.createElement(d, {
      id: "ds-tab-quaternario",
      label: a.title
    }, t.createElement(m, {
      isVisible: l === "ds-tab-quaternario"
    }, t.createElement(c, null, a)))), t.createElement(h, {
      componentName: o
    }));
  };
export { L as NewFooter };